import { render } from "./InquireForm.vue?vue&type=template&id=0e10e9d2"
import script from "./InquireForm.vue?vue&type=script&lang=js"
export * from "./InquireForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__